const footerLinks = [
  {
    title: '影视分类',
    links: ['热门电影', '热播电视剧', '综艺节目', '动漫动画', '纪录片', '经典怀旧'],
  },
  {
    title: '快速导航',
    links: ['热播榜单', '焦点专题', '最新快讯', '影视索引', '观众点评', '常见问答'],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '联系方式', '内容投稿', '商务合作', '问题反馈'],
  },
];

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const el = document.querySelector(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 dark-section pt-14 md:pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Top: Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-12 md:mb-16">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-xl text-white">大师兄影视</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">
              最新上映电影、热播电视剧、综艺节目高清免费在线观看。
              更新快抢先看，新片速递不卡顿，全集播放一网打尽。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Link groups */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading font-bold text-sm text-white mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href={`#${link}`}
                      onClick={(e) => {
                        e.preventDefault();
                        const map: Record<string, string> = {
                          '热门电影': '#index',
                          '热播电视剧': '#index',
                          '综艺节目': '#index',
                          '动漫动画': '#index',
                          '纪录片': '#index',
                          '经典怀旧': '#index',
                          '热播榜单': '#ranking',
                          '焦点专题': '#carousel',
                          '最新快讯': '#updates',
                          '影视索引': '#index',
                          '观众点评': '#comments',
                          '常见问答': '#faq',
                          '平台介绍': '#about',
                          '联系方式': '#contact',
                          '内容投稿': '#contact',
                          '商务合作': '#contact',
                          '问题反馈': '#contact',
                        };
                        const target = map[link];
                        if (target) {
                          scrollToSection(target);
                        }
                      }}
                      className="text-xs md:text-sm text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <h3 className="text-xs font-semibold text-white/30 uppercase tracking-wider mb-4">
            合作伙伴
          </h3>
          <div className="flex flex-wrap items-center gap-6">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="h-8 w-24 rounded-lg bg-white/5 flex items-center justify-center text-white/15 text-[10px] font-medium"
              >
                合作伙伴
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] md:text-xs text-foreground-500 text-center sm:text-left">
            &copy; 2026 大师兄影视. 本站内容仅供学习交流使用，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4 text-[11px] md:text-xs text-foreground-500">
            <span className="cursor-pointer hover:text-white transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-white transition-colors whitespace-nowrap">使用条款</span>
            <span className="cursor-pointer hover:text-white transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}